// extracted by mini-css-extract-plugin
export default {"SearchPanel":"ph_a bhe_ea bhe_kb bhe_js bhe_a bhe_j bhe_sm bhe_sn","SearchPanel__icon":"ph_b bhe_vm bhe_hg bhe_ss bhe_uy","SearchPanel__input":"ph_c bhe_iz bhe_eb bhe_z"};